import Base from './base'
import Vue from 'vue'

class Report extends Base {
  constructor () {
    super('Subject')
  }

  tracePage () {
    return new Promise(function (resolve, reject) {
      const data = {
        'agentName': Vue._config.name,
        'pageName': window.vm.$route.name,
        'operateLocation': '',
        'buttonName': '',
        'operateType': 1,
        'operateTime': 0
      }
      // 失败与否不去计较
      Vue.axios.post(Vue._config.api.report, { data: data }, { params: { open: true } })
      window._hmt && window._hmt.push(['_trackPageview', window.vm.$route.path])
      resolve(true)
    })
  }

  traceEvent (eventType, eventName) {
    return new Promise(function (resolve, reject) {
      const data = {
        'agentName': Vue._config.name,
        'pageName': window.vm.$route.name,
        'operateLocation': '',
        'buttonName': eventName,
        'operateType': 3,
        'operateTime': 0
      }
      // 失败与否不去计较
      Vue.axios.post(Vue._config.api.report, { data: data }, { params: { open: true } })
      // 如果是直接调用，没有走指令，那么就手动记录百度统计
      window._hmt && window._hmt.push(['_trackEvent', eventType, eventName])
      resolve(true)
    })
  }
}

export default new Report()
